import json2csv from 'json2csv'

export default (data, fields, fieldNames, fileName) => {
  try {
    var result = json2csv({
      data: data,
      fields: fields,
      fieldNames: fieldNames
    })
    var encodedUri = encodeURI(result)
    var link = document.createElement('a')
    link.setAttribute('href', 'data:text/csv; charset=utf-8,' + encodedUri)
    link.setAttribute('download', `${(fileName || 'file')}.csv`)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  } catch (err) {
    console.error(err)
  }
}



// WEBPACK FOOTER //
// ./src/helpers/CsvExport.js